import { render, staticRenderFns } from "./IconEmojiGreeting.vue?vue&type=template&id=cefe218a&"
import script from "./IconEmojiGreeting.vue?vue&type=script&lang=ts&"
export * from "./IconEmojiGreeting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports